//项目类别
export const constants_options_project_state = [
    { text: "招商线索", value: "招商线索" },
    { text: "前期接触", value: "前期接触" },
    { text: "预期落地", value: "预期落地" },
    { text: "过会未签", value: "过会未签" },
    { text: "已签未落", value: "已签未落" },
    { text: "已落未建", value: "已落未建" },
    { text: "开工建设", value: "开工建设" },
    { text: "建成投产", value: "建成投产" },
    { text: "投产达产", value: "投产达产" },
    { text: "已停止", value: "已停止" }]
//企业类型
export const constants_options_qylx = [
    { text: "央企", value: "央企" },
    { text: "地方国企", value: "地方国企" },
    { text: "上市企业", value: "上市企业" },
    { text: "世界500强", value: "世界500强" },
    { text: "中国500强", value: "中国500强" },
    { text: "行业龙头", value: "行业龙头" },
    { text: "其他", value: "其他" },
]
//计划落地
export const constants_optisons_jhld = [
    { value: "西部科学城九龙坡片区", text: "西部科学城九龙坡片区" },
    { value: "高铁临港经济区", text: "高铁临港经济区" },
    { value: "九龙新商圈", text: "九龙新商圈" },
    { value: "九龙美术半岛", text: "九龙美术半岛" },]
//产业类别
export const constants_options_cylb = [
    { text: "第一产业", value: 100 },
    { text: "第二产业", value: 101 },
    { text: "第三产业", value: 102 },
    { text: "一二三产融合", value: 103 },
]
//产业方向
export const constants_options_cyfx = [
    { text: "智能网联新能源汽车", value: "智能网联新能源汽车" },
    { text: "新一代电子信息制造业", value: "新一代电子信息制造业" },
    { text: "先进材料", value: "先进材料" },
    { text: "智能装备及智能制造", value: "智能装备及智能制造" },
    { text: "食品及农产品加工", value: "食品及农产品加工" },
    { text: "软件信息服务", value: "软件信息服务" },
    { text: "新型显示", value: "新型显示" },
    { text: "高端摩托车", value: "高端摩托车" },
    { text: "轻合金材料", value: "轻合金材料" },
    { text: "轻纺", value: "轻纺" },
    { text: "生物医药", value: "生物医药" },
    { text: "新能源及新型储能", value: "新能源及新型储能" },
    { text: "卫星互联网", value: "卫星互联网" },
    { text: "生物制造", value: "生物制造" },
    { text: "生命科学", value: "生命科学" },
    { text: "元宇宙", value: "元宇宙" },
    { text: "前沿新材料", value: "前沿新材料" },
    { text: "未来能源", value: "未来能源" },
    { text: "功率半导体及集成电路", value: "功率半导体及集成电路" },
    { text: "AI及机器人", value: "AI及机器人" },
    { text: "服务器", value: "服务器" },
    { text: "智能家居", value: "智能家居" },
    { text: "传感器及仪器仪表", value: "传感器及仪器仪表" },
    { text: "智能制造装备", value: "智能制造装备" },
    { text: "动力装备", value: "动力装备" },
    { text: "农机装备", value: "农机装备" },
    { text: "纤维及复合材料", value: "纤维及复合材料" },
    { text: "合成材料", value: "合成材料" },
    { text: "现代中药", value: "现代中药" },
    { text: "医疗器械", value: "医疗器械" },
    { text: "其他", value: "其他" }
]

//项目参与
export const constants_options_xmcy = [
    { text: "精准提供信息", value: "精准提供信息" },
    { text: "参与推动跟踪", value: "参与推动跟踪" },
    { text: "全程落地跟踪", value: "全程落地跟踪" },

]
//合同类型
export const constants_options_htlx = [
    { text: "正式合同", value: "正式合同" },
    { text: "框架协议", value: "框架协议" },

]